<!--
 * @Description: ipo进行时列表
 * @Author:  单珊珊
 * @Date: 2022-02-16 09:57:10
 * @LastEditTime: 2022-05-06 16:26:42
 * @LastEditors:  
-->
<template>
<div class="company-filter">
  <div class="ipo-prospectus common-container">
    
    <div class="ipo-wrap" style="margin-right 30px;">
      <div class="header">
        <div class="left title-underline">IPO进行时</div>
        <!-- <div class="right orange more">查看更多</div> -->
      </div>
      <div class="ipo-list">
        
        <div class="ipo-item" v-for="item, index in ipo_list" :key="index">
          <div class="title">
            <div class="ipo-title" @click="goToIpoDetail(item)">
              <i v-if="item.type == 1" class="iconfont wenzhang">&#xe6bc;</i>
              <i v-if="item.type == 0" class="iconfont kuaixun">&#xe6bd;</i>
              {{item.title}}
              </div>
            <div class="time">{{item.eventTime | time_moment}}</div>
          </div>
          <div class="content">
            <div class="org-info" style="width: 240px;">
              <div class="org-logo">
                <img :src="img_req_url + item.entityLogoPath" />
              </div>
              <div class="right">
                <p class="org-name over-p1" @click="toEntity(item.entityType, item.entityUid)">{{item.entityShortName}}</p>
                <p class="org-business  over-p1">{{item.entityDescription}}</p>
              </div>
            </div>
            <div class="tracks" style="width:385px;">
              <div class="normal" v-if="item.entityTags.length > 0">相关赛道</div>
              <div>
                <span class="topic" v-show="index1 < 3" v-for="tag,index1 in item.entityTags" 
                :key="index1"
                @click="goToTrackDetail(tag.id)">{{tag.name}}</span>
              </div>
            </div>
            <div class="download" v-if="item.prospectus">
              <!-- <i class="iconfont">&#xe644;</i>招股书下载 -->
              <i class="iconfont">&#xe644;</i><span @click="goTopProspectus(item.entityUid)">招股书下载</span>
            </div>
            <div class="firbden-download" v-else>
              <i class="iconfont">&#xe644;</i><span>招股书下载</span>
            </div>
          </div>
        </div>

        <Spin v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="defalut" v-if="!loading && ipo_list.length < 1">
          <img :src="$store.state.static_img_url+'pic/quesheng-2.png'" alt="" srcset="">
          <p>暂无相关内容</p>
        </div>
        <div class="more-btn" v-if="length == 20 && !loading">
          <div @click="getMoreList">加载更多</div>
        </div>
      </div>
    </div>
    <RightModel class="right-wrap">
      <rcTrack></rcTrack>
      <activeTrack class="item"></activeTrack>
      <activeAgency class="item"></activeAgency>
      <prospectus class="item"></prospectus>
    </RightModel>
  </div>
</div>
</template>
<script>
import prospectus from './components/Prospectus'
import activeAgency from '@/components/vcbeat/ActiveAgency.vue'
import activeTrack from '@/components/vcbeat/Activetrack.vue'
import rcTrack from '@/components/vcbeat/RCtrack.vue'
import { getMeta, getIponews } from '@/service.js'
import filter from 'js/filter'
import RightModel from '@/components/RightModel'
export default {
  components: { prospectus, activeAgency, activeTrack, rcTrack, RightModel },
  data() {
    return {
      loading: true,
      entity_ntag: [],
      ipo_list: [],
      scroll: '',
      LOCK_STATUS: false, //正在请求数据时，锁定滚动不再请求分页
      current_page_index: 1, //当前页
      current_data_list: [],
      length: 0
    }
  },
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    },
  },
  beforeMount() {
    this.getMeta()
  },
  mounted() {
    
  },
  destroyed() {
  },
  methods: {
    //获取赛道
    async getMeta() {
      let res = await getMeta({name: ['entity_ntag']},(error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        this.entity_ntag = res.meta.entity_ntag
        this.getIponews()
      }
    },
    //ipo列表
    async getIponews(){
      this.length = 0
      this.loading = true
      let res = await getIponews({page: this.current_page_index}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.code == 0) {
        this.current_data_list = res.data
        this.length = this.current_data_list.length
        this.current_data_list.map(item => {
          let ids = item.entityApplayerTagStr ? item.entityApplayerTagStr.split(',') : []
          let entityTags = []
          ids.map(id => {
            entityTags.push({
              id: id,
              name: filter.dealNeed(id, this.entity_ntag)
            })
          })
          this.$set(item, 'entityTags', entityTags)
        })
        this.ipo_list = [...this.ipo_list, ...this.current_data_list]
        this.loading = false
      }
    },
    getMoreList() {
      if (this.length == 20) {
        ++this.current_page_index
        this.getIponews()
      }
    },
    // 滚动条防抖
    debounce(fn, wait){
      let timeout = null
      return () => {        
        if(timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)  
      }
    },
    //跳转至赛道详情
    goToTrackDetail(id) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: id } })
      window.open(href, '_blank')
    },
    //跳转至ipo快讯、文章详情
    goToIpoDetail(item) {
      console.log('item', item.type);
      switch(item.type) {
        case 1:
          const temp_href = this.$store.state.index2_path + '/' + item.id
          window.open(temp_href, '_blank')
          break;
        case 0:
          const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
          window.open(href, '_blank')
          break;
      }
    },
    //跳转至公司详情-招股书下载
    goTopProspectus(id) {
      const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: id }, query: { fromPath: 'track' } })
      window.open(href, '_blank')
    },
     //跳转至公司或机构详情
    toEntity(type, id) {
      if(type == 0){
        const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: id } })
        window.open(href, '_blank')
      }else if(type == 1){
        const { href } = this.$router.resolve({ name: 'OrgDetail', params: { uid: id } })
        window.open(href, '_blank')
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
@import '~styles/common_vcbeat.stylus'
.company-filter
  background #fff
  display flex
  justify-content center
.common-container
  margin 20px auto
  width 1200px
  position relative
  .ipo-wrap
    width 866px
    margin-right 30px
    .ipo-list
      // overflow auto
      margin-top 20px
      >>> .download
        margin-left: 70px !important
      >>> .firbden-download
        margin-left: 70px !important
  .right-wrap
    width 304px
    .item
      margin-top 30px
  >>>.ivu-spin
    margin-top 20px
    color #FA5A00
  .more-btn
    margin-top 30px
    display flex
    justify-content center
    > div
      width 136px
      height 40px
      background #FFFFFF
      border 1px solid #FA5A00
      border-radius 20px
      display flex
      justify-content center
      align-items center
      font-size 14px
      color #FA7A50
      cursor pointer
      transition all 0.2s
      &:hover
        background #FA5A00
        color #FFFFFF
  .defalut
    display flex
    flex-direction column
    align-items center
    img
      height 156px
    p
      color #999
      font-size 14px
</style>